import {
    ADD_KEY_IMAGE,
    ADD_MEDIA_TO_DISCLAIMER_OFFLINE,
    ADD_MEDIA_TO_REPORT_OFFLINE,
    ADD_NEW_ALARM_INTO_REPORT,
    ADD_NEW_DISCLAIMER_INTO_REPORT,
    ADD_NEW_GROUP_AT_LAST,
    ADD_NEW_ITEM_AT_LAST,
    ADD_NEW_KEY_INTO_REPORT,
    ADD_NEW_METER_INTO_REPORT,
    ADD_NEW_READING_IN_METER,
    ADD_NEW_RECEIPT_INTO_REPORT,
    ADD_NEW_ROOM_AT_LAST,
    CLEAR_DATA,
    DELETE_ALARM_IN_REPORT,
    DELETE_DISCLAIMER_IN_REPORT,
    DELETE_KEY_IN_REPORT,
    DELETE_METER_IN_REPORT,
    DELETE_READING_IN_METER,
    DELETE_RECEIPT_IN_REPORT,
    GET_CREATE_REPORT_DETAILS,
    LOAD_ROOM_TEMPLATE,
    LOAD_SAVE_STATE,
    LOAD_AI_DATA,
    REMOVE_GROUP_FROM_REPORT,
    REMOVE_ITEM_FROM_REPORT,
    REMOVE_MEDIA_FROM_DISCLAIMER_OFFLINE,
    REMOVE_MEDIA_FROM_REPORT_OFFLINE,
    REMOVE_ROOM_FROM_REPORT,
    RESET_CUSTOM_OBJECT_FROM_REPORT_UPDATE,
    RESET_REPORT_UPDATE_DATA,
    UPDATE_ALARM_IN_REPORT,
    UPDATE_DISCLAIMER_IN_REPORT,
    UPDATE_GROUP_IN_REPORT,
    UPDATE_ITEM_IN_REPORT,
    UPDATE_KEY_IN_REPORT,
    UPDATE_METER_IN_REPORT,
    UPDATE_METER_ABSENCE_IN_REPORT,
    UPDATE_READING_IN_METER,
    UPDATE_RECEIPT_IN_REPORT,
    UPDATE_REPORT_AS_IMAGE_DELETED,
    UPDATE_ROOM_IN_REPORT,
    UPDATE_ADDITIONAL_SUMMARY_IN_REPORT,
    LOG_ERROR_RESPONSE,
    SET_SELECTED_OVERLAY_IMAGE,
    UPDATE_OVERLAY_IMAGE_LIST
} from '../actions/report_action';

import {CreateReducer} from '../utils/create_reducer';

const uuidv1 = require('uuid/v1');

const initState = {
    successStatus: false,
    statusMessage: null,
    isFetching: true,
    reportDetails: [],
    attachment: [],
    change: false,
    reportUpdates: {
        report_id: undefined,
        rooms: [],
        groups: [],
        items: []
    },
    reportUpdateKeys:{
        report_id:undefined,
        keys:[],
        images:[]
    },
    reportUpdateMeters:{
        report_id:undefined,
        meters:[],
        readings:[]
    },
    reportUpdateAlarms:{
        report_id:undefined,
        alarms:[],
    },
    reportUpdateReceipts:{
        report_id:undefined,
        receipts:[],
    },
    reportUpdateDisclaimer:{
        report_id:undefined,
        disclaimers:[],
        images:[]
    }

};

const getIndexOfObjectIfExists = (arrObj, searchId) => {
    for (let i = 0; i < arrObj.length; i++) {
        if (arrObj[i]['client_id'] === searchId) {
            return i;
        }
    }
    return -1;
};


const reportReducer = CreateReducer(initState, {

[GET_CREATE_REPORT_DETAILS](state, action) {
  const reportId = action.payload.report.id;

  return {
    ...state, // Copy all top-level properties from the existing state
    reportDetails: action.payload.report, // Update reportDetails
    isFetching: false, // Update isFetching

    // Create new objects for each 'reportUpdate' property
    reportUpdates: { ...state.reportUpdates, report_id: reportId },
    reportUpdateKeys: { ...state.reportUpdateKeys, report_id: reportId },
    reportUpdateMeters: { ...state.reportUpdateMeters, report_id: reportId },
    reportUpdateAlarms: { ...state.reportUpdateAlarms, report_id: reportId },
    reportUpdateReceipts: { ...state.reportUpdateReceipts, report_id: reportId },
    reportUpdateDisclaimer: { ...state.reportUpdateDisclaimer, report_id: reportId },
  };
},
   [ADD_NEW_ROOM_AT_LAST](state, action) {
    // Create deep copy of reportDetails
    const newReportDetails = {
        ...state.reportDetails,
        rooms: [...state.reportDetails.rooms, { ...action.roomObject }]
    };

    // Create deep copy of reportUpdates
    const newReportUpdates = {
        ...state.reportUpdates,
        rooms: [...state.reportUpdates.rooms, { new: true, ...action.roomObject }]
    };


    return {
        ...state,
        reportDetails: newReportDetails,
        reportUpdates: newReportUpdates,
        change: !state.change
    };
},

[ADD_NEW_GROUP_AT_LAST](state, action) {
    // Create deep copy of reportDetails with updated rooms array
    const newReportDetails = {
        ...state.reportDetails,
        rooms: state.reportDetails.rooms.map((room, index) => 
            index === action.roomIndex 
                ? {
                    ...room,
                    groups: [...room.groups, { ...action.groupObject }]
                }
                : room
        )
    };

    // Create deep copy of reportUpdates with new group added
    const newReportUpdates = {
        ...state.reportUpdates,
        groups: [...state.reportUpdates.groups, { ...action.groupObject }]
    };

    console.log({
        "console log for newgroupdetails": newReportDetails,
        "console log for newreportupdates:": newReportUpdates
    });

    return {
        ...state,
        reportDetails: newReportDetails,
        reportUpdates: newReportUpdates,
        change: !state.change
    };
},

[ADD_NEW_ITEM_AT_LAST](state, action) {
    // Create deep copy of reportDetails with updated nested structure
    const newReportDetails = {
        ...state.reportDetails,
        rooms: state.reportDetails.rooms.map((room, roomIndex) =>
            roomIndex === action.roomIndex
                ? {
                    ...room,
                    groups: room.groups.map((group, groupIndex) =>
                        groupIndex === action.groupIndex
                            ? {
                                ...group,
                                items: [...group.items, { ...action.itemObject }]
                            }
                            : group
                    )
                }
                : room
        )
    };

    // Create deep copy of reportUpdates with new item added
    const newReportUpdates = {
        ...state.reportUpdates,
        items: [...state.reportUpdates.items, { ...action.itemObject }]
    };

    console.log({
        "console log for newItemDetails": newReportDetails,
        "console log for newreportupdates:": newReportUpdates
    });

    return {
        ...state,
        reportDetails: newReportDetails,
        reportUpdates: newReportUpdates,
        change: !state.change
    };
},
   [ADD_MEDIA_TO_REPORT_OFFLINE](state, action) {
    // Create new attachment array with added media
    const newAttachment = [...state.attachment, action.media];
    if (action.itemIndex !== -1) {
        // Adding media to an item
        const currentItem = state.reportDetails.rooms[action.roomIndex].groups[action.groupIndex].items[action.itemIndex];
        
        // Create new image object
        const newImage = {
            id: action.media.id,
            image: action.media,
            ...(action.media.image_path && { image_path: action.media.image_path }),
            ...(action.media.additionalImgId && { additionalImgId: action.media.additionalImgId })
        };
        
        // Create updated item with new image
        const updatedItem = {
            ...currentItem,
            action: currentItem.action || 'update',
            images: [...currentItem.images, newImage]
        };
        
        // Update reportDetails immutably
        const newReportDetails = {
            ...state.reportDetails,
            rooms: state.reportDetails.rooms.map((room, roomIdx) =>
                roomIdx === action.roomIndex
                    ? {
                        ...room,
                        groups: room.groups.map((group, groupIdx) =>
                            groupIdx === action.groupIndex
                                ? {
                                    ...group,
                                    items: group.items.map((item, itemIdx) =>
                                        itemIdx === action.itemIndex ? updatedItem : item
                                    )
                                }
                                : group
                        )
                    }
                    : room
            )
        };
        
        // Update reportUpdates immutably
        const index = getIndexOfObjectIfExists(state.reportUpdates.items, updatedItem.client_id);
        let newReportUpdates;
        
        if (index !== -1) {
            newReportUpdates = {
                ...state.reportUpdates,
                items: state.reportUpdates.items.map((item, idx) =>
                    idx === index ? updatedItem : item
                )
            };
        } else {
            newReportUpdates = {
                ...state.reportUpdates,
                items: [...state.reportUpdates.items, updatedItem]
            };
        }
        
        return {
            ...state,
            attachment: newAttachment,
            reportDetails: newReportDetails,
            reportUpdates: newReportUpdates,
            change: !state.change
        };
    } else {
        // Adding media to a room
        const currentRoom = state.reportDetails.rooms[action.roomIndex];
        
        // Create new image object
        const newImage = {
            id: action.media.id,
            image: action.media,
            ...(action.media.image_path && { image_path: action.media.image_path }),
            ...(action.media.additionalImgId && { additionalImgId: action.media.additionalImgId })
        };
        
        // Create updated room with new image
        const updatedRoom = {
            ...currentRoom,
            action: currentRoom.action || 'update',
            images: [...currentRoom.images, newImage]
        };
        
        // Update reportDetails immutably
        const newReportDetails = {
            ...state.reportDetails,
            rooms: state.reportDetails.rooms.map((room, idx) =>
                idx === action.roomIndex ? updatedRoom : room
            )
        };
        
        // Create room object for updates
        const roomObjUpdate = {
            name: updatedRoom.name,
            client_id: updatedRoom.client_id,
            groups: [],
            action: updatedRoom.action,
            images: updatedRoom.images,
        };
        
        // Update reportUpdates immutably
        const index = getIndexOfObjectIfExists(state.reportUpdates.rooms, updatedRoom.client_id);
        let newReportUpdates;
        
        if (index !== -1) {
            newReportUpdates = {
                ...state.reportUpdates,
                rooms: state.reportUpdates.rooms.map((room, idx) =>
                    idx === index ? roomObjUpdate : room
                )
            };
        } else {
            newReportUpdates = {
                ...state.reportUpdates,
                rooms: [...state.reportUpdates.rooms, roomObjUpdate]
            };
        }
        
        return {
            ...state,
            attachment: newAttachment,
            reportDetails: newReportDetails,
            reportUpdates: newReportUpdates,
            change: !state.change
        };
    }
},

[UPDATE_ROOM_IN_REPORT](state, action) {
    // Update reportDetails immutably
    const newReportDetails = {
        ...state.reportDetails,
        rooms: state.reportDetails.rooms.map((room, idx) =>
            idx === action.roomIndex ? { ...action.roomObject } : room
        )
    };

    // Check if room already exists in API update call
    const uuidOfRoomObject = action.roomObject.client_id;
    const index = getIndexOfObjectIfExists(state.reportUpdates.rooms, uuidOfRoomObject);
    
    let newReportUpdates;
    if (index !== -1) {
        newReportUpdates = {
            ...state.reportUpdates,
            rooms: state.reportUpdates.rooms.map((room, idx) =>
                idx === index ? { ...action.roomObject } : room
            )
        };
    } else {
        newReportUpdates = {
            ...state.reportUpdates,
            rooms: [...state.reportUpdates.rooms, { ...action.roomObject }]
        };
    }
    
    return {
        ...state,
        reportDetails: newReportDetails,
        reportUpdates: newReportUpdates,
        change: !state.change
    };
},

[UPDATE_GROUP_IN_REPORT](state, action) {
    // Update reportDetails immutably
    const newReportDetails = {
        ...state.reportDetails,
        rooms: state.reportDetails.rooms.map((room, roomIdx) =>
            roomIdx === action.roomIndex
                ? {
                    ...room,
                    groups: room.groups.map((group, groupIdx) =>
                        groupIdx === action.groupIndex ? { ...action.groupObject } : group
                    )
                }
                : room
        )
    };

    // Check if group already exists in API update call
    const uuidOfGroupObject = action.groupObject.client_id;
    const index = getIndexOfObjectIfExists(state.reportUpdates.groups, uuidOfGroupObject);
    
    let newReportUpdates;
    if (index !== -1) {
        newReportUpdates = {
            ...state.reportUpdates,
            groups: state.reportUpdates.groups.map((group, idx) =>
                idx === index ? { ...action.groupObject } : group
            )
        };
    } else {
        newReportUpdates = {
            ...state.reportUpdates,
            groups: [...state.reportUpdates.groups, { ...action.groupObject }]
        };
    }
    
    return {
        ...state,
        reportDetails: newReportDetails,
        reportUpdates: newReportUpdates,
        change: !state.change
    };
},

[UPDATE_ITEM_IN_REPORT](state, action) {
    // Update reportDetails immutably
    const newReportDetails = {
        ...state.reportDetails,
        rooms: state.reportDetails.rooms.map((room, roomIdx) =>
            roomIdx === action.roomIndex
                ? {
                    ...room,
                    groups: room.groups.map((group, groupIdx) =>
                        groupIdx === action.groupIndex
                            ? {
                                ...group,
                                items: group.items.map((item, itemIdx) =>
                                    itemIdx === action.itemIndex ? { ...action.itemObject } : item
                                )
                            }
                            : group
                    )
                }
                : room
        )
    };

    // Check if Item already exists in API update call
    const uuidOfItemObject = action.itemObject.client_id;
    const index = getIndexOfObjectIfExists(state.reportUpdates.items, uuidOfItemObject);
    
    let newReportUpdates;
    if (index !== -1) {
        newReportUpdates = {
            ...state.reportUpdates,
            items: state.reportUpdates.items.map((item, idx) =>
                idx === index ? { ...action.itemObject } : item
            )
        };
    } else {
        newReportUpdates = {
            ...state.reportUpdates,
            items: [...state.reportUpdates.items, { ...action.itemObject }]
        };
    }

    return {
        ...state,
        reportDetails: newReportDetails,
        reportUpdates: newReportUpdates,
        change: !state.change
    };
},

[REMOVE_MEDIA_FROM_REPORT_OFFLINE](state, action) {
    // Remove media from attachment array immutably
    const newAttachment = state.attachment.filter(attachment => 
        attachment.id !== action.media.id
    );
    
    return {
        ...state,
        attachment: newAttachment
    };
},
  [REMOVE_ROOM_FROM_REPORT](state, action) {
    const roomToBeDeleted = state.reportDetails.rooms[action.roomIndex];
    const roomImages = roomToBeDeleted && roomToBeDeleted.images ? roomToBeDeleted.images : [];

    // Remove room images from attachments
    const roomImageIds = roomImages.map(function(img) {
        return img.id ? img.id : img.upload && img.upload.uuid;
    });

    let newAttachments = state.attachment.filter(function(att) {
        return roomImageIds.indexOf(att.id) === -1;
    });

    // Collect group IDs inside the room
    let groupsToDeleted = [];
    if (roomToBeDeleted && roomToBeDeleted.groups) {
        groupsToDeleted = roomToBeDeleted.groups.map(function(group) {
            return group.client_id;
        });
    }

    // Remove items that belong to groups inside this room
    const newItems = state.reportUpdates.items.filter(function(item) {
        if (groupsToDeleted.indexOf(item.group_id) === -1) {
            return true;
        }
        // Also remove item images from attachments (immutably)
        const itemImages = item.images || [];
        const itemImageIds = itemImages.map(function(img) {
            return img.id ? img.id : img.upload && img.upload.uuid;
        });
        
        // Filter out item images from attachments array
        newAttachments = newAttachments.filter(function(att) {
            return itemImageIds.indexOf(att.id) === -1;
        });
        
        return false;
    });

    // Remove groups that belong to the room
    const newGroups = state.reportUpdates.groups.filter(function(group) {
        return group.room_id !== roomToBeDeleted.client_id;
    });

    // Remove room from reportUpdates.rooms if exists
    let newReportUpdateRooms = state.reportUpdates.rooms.filter(function(room) {
        return room.client_id !== roomToBeDeleted.client_id;
    });

    // If it wasn't just created, mark it for delete
    if (roomToBeDeleted && roomToBeDeleted.action !== 'create') {
        newReportUpdateRooms = [...newReportUpdateRooms, {
            client_id: roomToBeDeleted.client_id,
            name: "",
            groups: [],
            images: [],
            action: 'delete'
        }];
    }

    // Finally, remove the room from reportDetails
    const newRooms = state.reportDetails.rooms.filter(function(_, idx) {
        return idx !== action.roomIndex;
    });

    return {
        ...state,
        attachment: newAttachments,
        reportDetails: {
            ...state.reportDetails,
            rooms: newRooms
        },
        reportUpdates: {
            ...state.reportUpdates,
            items: newItems,
            groups: newGroups,
            rooms: newReportUpdateRooms
        },
        change: !state.change
    };
},

[REMOVE_GROUP_FROM_REPORT](state, action) {
    const groupToBeDeleted = state.reportDetails.rooms[action.roomIndex] && state.reportDetails.rooms[action.roomIndex].groups
        ? state.reportDetails.rooms[action.roomIndex].groups[action.groupIndex]
        : null;

    if (!groupToBeDeleted) {
        return { ...state };
    }

    const groupId = groupToBeDeleted.client_id;

    // Start with current attachments
    let newAttachments = [...state.attachment];

    // Remove items belonging to the group
    const newItems = state.reportUpdates.items.filter(function(item) {
        if (item.group_id !== groupId) {
            return true;
        }
        // Also remove associated images from attachments (immutably)
        const itemImages = item.images || [];
        const itemImageIds = itemImages.map(function(img) {
            return img.id ? img.id : img.upload && img.upload.uuid;
        });
        
        // Filter out item images from attachments array
        newAttachments = newAttachments.filter(function(att) {
            return itemImageIds.indexOf(att.id) === -1;
        });
        
        return false;
    });

    // Remove group from groups
    let newGroups = state.reportUpdates.groups.filter(function(group) {
        return group.client_id !== groupId;
    });

    // If not newly created, mark group for deletion
    if (groupToBeDeleted.action !== 'create') {
        newGroups = [...newGroups, {
            client_id: groupToBeDeleted.client_id,
            name: "",
            items: [],
            action: 'delete',
            room_id: action.roomId
        }];
    }

    // Remove group from reportDetails
    const newRooms = state.reportDetails.rooms.map(function(room, idx) {
        if (idx !== action.roomIndex) return room;
        const newGroupsInRoom = room.groups.filter(function(_, gIdx) {
            return gIdx !== action.groupIndex;
        });
        return { ...room, groups: newGroupsInRoom };
    });

    return {
        ...state,
        attachment: newAttachments,
        reportDetails: {
            ...state.reportDetails,
            rooms: newRooms
        },
        reportUpdates: {
            ...state.reportUpdates,
            items: newItems,
            groups: newGroups
        },
        change: !state.change
    };
},

[REMOVE_ITEM_FROM_REPORT](state, action) {
    const room = state.reportDetails.rooms[action.roomIndex];
    const group = room && room.groups ? room.groups[action.groupIndex] : null;
    const itemToBeDeleted = group && group.items ? group.items[action.itemIndex] : null;

    if (!itemToBeDeleted) {
        return { ...state };
    }

    const itemId = itemToBeDeleted.client_id;
    const itemImages = itemToBeDeleted.images || [];

    // Remove item images from attachments (immutably)
    const itemImageIds = itemImages.map(function(img) {
        return img.id ? img.id : img.upload && img.upload.uuid;
    });

    const newAttachments = state.attachment.filter(function(att) {
        return itemImageIds.indexOf(att.id) === -1;
    });

    // Remove item from reportUpdates.items
    let newItems = state.reportUpdates.items.filter(function(item) {
        return item.client_id !== itemId;
    });

    // If item is not newly created, add a delete action
    if (itemToBeDeleted.action !== 'create') {
        newItems = [...newItems, {
            client_id: itemToBeDeleted.client_id,
            ci_notes: "",
            name: itemToBeDeleted.name,
            co_notes: "",
            group_id: itemToBeDeleted.group_id,
            images: [],
            action: 'delete'
        }];
    }

    // Remove item from reportDetails
    const newRooms = state.reportDetails.rooms.map(function(room, idx) {
        if (idx !== action.roomIndex) return room;
        const newGroups = room.groups.map(function(grp, gIdx) {
            if (gIdx !== action.groupIndex) return grp;
            const newItemsInGroup = grp.items.filter(function(_, iIdx) {
                return iIdx !== action.itemIndex;
            });
            return { ...grp, items: newItemsInGroup };
        });
        return { ...room, groups: newGroups };
    });

    return {
        ...state,
        attachment: newAttachments,
        reportDetails: {
            ...state.reportDetails,
            rooms: newRooms
        },
        reportUpdates: {
            ...state.reportUpdates,
            items: newItems
        },
        change: !state.change
    };
},
    [CLEAR_DATA](state, action) {
        return {
            ...initState,
            reportUpdates: state.reportUpdates,  // preserve cleared report updates
            attachment: state.attachment,        // preserve cleared attachments
            change: !state.change
        };
    },    
    [RESET_REPORT_UPDATE_DATA](state, action) {
            const newState = {
                ...state,
                reportUpdates: {
                    ...state.reportUpdates, // retaining report_id
                    rooms: [],
                    groups: [],
                    items: []
                }
            };
            if (action.removeImages) {
                newState.attachment = [];
            }
            return newState;
        } ,      
  [UPDATE_REPORT_AS_IMAGE_DELETED](state, action) {
  const media = action.media || {};
console.log("removing media from report")
  // 1. Handle top-level 'attachment' array immutably
  const updatedAttachments = (state.attachment || []).filter(
    (attachment) =>
      !(
        attachment.id === media.id ||
        (media.upload && attachment.id === media.upload.uuid) ||
        attachment.id === media.serverId
      )
  );

  // Start building the new state object
  let newState = {
    ...state,
    attachment: updatedAttachments,
  };

  // 2. Handle nested reportDetails changes immutably
  if (action.itemIndex !== -1) {
    // Deep copy reportDetails to avoid direct mutation
    let newReportDetails = {
      ...newState.reportDetails,
      rooms: [...(newState.reportDetails.rooms || [])],
    };

    if (
      newReportDetails.rooms[action.roomIndex] &&
      newReportDetails.rooms[action.roomIndex].groups &&
      newReportDetails.rooms[action.roomIndex].groups[action.groupIndex] &&
      newReportDetails.rooms[action.roomIndex].groups[action.groupIndex].items &&
      newReportDetails.rooms[action.roomIndex].groups[action.groupIndex].items[
        action.itemIndex
      ]
    ) {
      // Copy the specific room, group, and item to modify
      const newRoom = { ...newReportDetails.rooms[action.roomIndex] };
      const newGroup = { ...newRoom.groups[action.groupIndex] };
      const newItem = {
        ...newGroup.items[action.itemIndex],
      };

      // Update 'action' if it doesn't exist
      if (!newItem.action) {
        newItem.action = 'update';
      }

      // Filter out the deleted image from the item's images array
      newItem.images = (newItem.images || []).filter(
        (image) =>
          !(
            image.id === media.id ||
            (media.upload && image.id === media.upload.uuid) ||
            image.id === media.serverId
          )
      );

      // Reconstruct the state with the updated item
      newGroup.items = newGroup.items.map((item, index) =>
        index === action.itemIndex ? newItem : item
      );
      newRoom.groups = newRoom.groups.map((group, index) =>
        index === action.groupIndex ? newGroup : group
      );
      newReportDetails.rooms = newReportDetails.rooms.map((room, index) =>
        index === action.roomIndex ? newRoom : room
      );

      newState.reportDetails = newReportDetails;

      // 3. Handle reportUpdates.items immutably
      let newReportUpdates = {
        ...newState.reportUpdates,
        items: [...(newState.reportUpdates.items || [])],
      };

      const itemIndexInUpdates = getIndexOfObjectIfExists(
        newReportUpdates.items,
        newItem.client_id
      );

      if (itemIndexInUpdates !== -1) {
        newReportUpdates.items = newReportUpdates.items.map((item, index) =>
          index === itemIndexInUpdates ? newItem : item
        );
      } else {
        newReportUpdates.items = [...newReportUpdates.items, newItem];
      }
      newState.reportUpdates = newReportUpdates;
    }
  } else {
    // Handle room-level image deletion (similar immutable approach)
    let newReportDetails = {
      ...newState.reportDetails,
      rooms: [...(newState.reportDetails.rooms || [])],
    };

    if (newReportDetails.rooms[action.roomIndex]) {
      const newRoomOnChange = {
        ...newReportDetails.rooms[action.roomIndex],
      };

      if (!newRoomOnChange.action) {
        newRoomOnChange.action = 'update';
      }

      newRoomOnChange.images = (newRoomOnChange.images || []).filter(
        (image) =>
          !(
            image.id === media.id ||
            (media.upload && image.id === media.upload.uuid) ||
            image.id === media.serverId
          )
      );

      newReportDetails.rooms = newReportDetails.rooms.map((room, index) =>
        index === action.roomIndex ? newRoomOnChange : room
      );
      newState.reportDetails = newReportDetails;

      // Handle reportUpdates.rooms immutably
      let newReportUpdates = {
        ...newState.reportUpdates,
        rooms: [...(newState.reportUpdates.rooms || [])],
      };

      const roomIndexInUpdates = getIndexOfObjectIfExists(
        newReportUpdates.rooms,
        newRoomOnChange.client_id
      );

      if (roomIndexInUpdates !== -1) {
        newReportUpdates.rooms = newReportUpdates.rooms.map((room, index) =>
          index === roomIndexInUpdates ? newRoomOnChange : room
        );
      } else {
        newReportUpdates.rooms = [...newReportUpdates.rooms, newRoomOnChange];
      }
      newState.reportUpdates = newReportUpdates;
    }
  }

  // Return the new state object
  return newState;
},    
    [ADD_NEW_KEY_INTO_REPORT](state, action) {
        let newReportDetails = state.reportDetails;
        newReportDetails.keys.push(action.keysObject);
        let newReportUpdateKeys = state.reportUpdateKeys;
        newReportUpdateKeys.keys.push(action.keysObject);
        return {...state, reportDetails: newReportDetails,reportUpdateKeys:newReportUpdateKeys,change:!state.change}
    },
    [UPDATE_KEY_IN_REPORT](state, action) {
        let newReportDetails = state.reportDetails;
        const index = getIndexOfObjectIfExists(newReportDetails.keys,action.keysObject['client_id']);
        if(index !== -1){
            newReportDetails.keys[index] = action.keysObject;
        }
        let newReportUpdateKeys = state.reportUpdateKeys;
        const uindex = getIndexOfObjectIfExists(newReportUpdateKeys.keys,action.keysObject['client_id']);
        if(uindex !== -1){
            newReportUpdateKeys.keys[uindex] = action.keysObject;
        }
        else {
            newReportUpdateKeys.keys.push(action.keysObject);
        }
        return {...state, reportDetails: newReportDetails,reportUpdateKeys:newReportUpdateKeys,change:!state.change}
    },
    [DELETE_KEY_IN_REPORT](state, action) {
        let newReportDetails = state.reportDetails;
        const index = getIndexOfObjectIfExists(newReportDetails.keys,action.keysObject['client_id']);
        if(index !== -1){
            newReportDetails.keys.splice(index,1);
        }
        let newReportUpdateKeys = state.reportUpdateKeys;
        const uindex = getIndexOfObjectIfExists(newReportUpdateKeys.keys,action.keysObject['client_id']);
        if(uindex !== -1){
                if(newReportUpdateKeys.keys[uindex]['action'] === 'create'){
                    newReportUpdateKeys.keys.splice(uindex,1);
                }
                else {
                    newReportUpdateKeys.keys[uindex] = {...action.keysObject,action:'delete'};
                }

        }
        else {
            newReportUpdateKeys.keys.push({...action.keysObject,action:'delete'});
        }
        return {...state, reportDetails: newReportDetails,reportUpdateKeys:newReportUpdateKeys,change:!state.change}
    },
    [RESET_CUSTOM_OBJECT_FROM_REPORT_UPDATE](state,action){

        switch(action.objectToReset){
            case 'keys':
                let newReportDetails = state.reportDetails;
                newReportDetails.keys.forEach(key => key.action = null);
                let newReportUpdateKeys = state.reportUpdateKeys;
                newReportUpdateKeys.keys = []
                newReportUpdateKeys.images = null
                newReportUpdateKeys.ci_images = null
                return { ...state, reportDetails: newReportDetails, reportUpdateKeys: newReportUpdateKeys, change: !state.change }
                break;
            case 'meters':
                let newReportUpdateMeters = state.reportUpdateMeters
                newReportUpdateMeters.meters.length = 0
                newReportUpdateMeters.readings.length = 0
                let newReportDetailsMeters = state.reportDetails;
                newReportDetailsMeters.meters.forEach(meter => { meter.action = null; meter.readings.forEach(reading => reading.action = null) });
                return { ...state, reportDetails: newReportDetailsMeters, reportUpdateMeters: newReportUpdateMeters, change: !state.change }
            case 'alarms':
                let newReportDetailsAlarms = state.reportDetails
                newReportDetailsAlarms.alarms.forEach(alarm => alarm.action = null)
                state.reportUpdateAlarms.alarms.length = 0;
                return {...state, reportDetails:newReportDetailsAlarms}
                break;
            case 'receipts':
                let newReportDetailsReceipts = state.reportDetails
                newReportDetailsReceipts.receipts.forEach(receipt => receipt.action = null)
                state.reportUpdateReceipts.receipts.length = 0;
                return {...state, reportDetails:newReportDetailsReceipts}
                break;
            case 'disclaimers':
                let newReportDetailsDisclaimers = state.reportDetails
                newReportDetailsDisclaimers.disclaimers.forEach(disclaimer => disclaimer.action = null)
                state.reportUpdateDisclaimer.disclaimers.length = 0;
                state.reportUpdateDisclaimer.images.length = 0;
                return {...state, reportDetails:newReportDetailsDisclaimers}
                break;
            default :
                break;
        }
        return {...state}
    },
    [ADD_KEY_IMAGE](state,action){
        if(action.inspectionType === 'co'){
            state.reportDetails['co_keys_image'] = {id:action.imageId,dataURL:action.dataURL};
        }
        else {
            state.reportDetails['ci_keys_image'] = {id:action.imageId,dataURL:action.dataURL};
        }
        return {...state,change:!state.change}
    },
    [ADD_NEW_ALARM_INTO_REPORT](state,action){
        let newReportDetails = state.reportDetails;
        newReportDetails.alarms.push(action.alarmObject);
        let newReportUpdateAlarm = state.reportUpdateAlarms;
        newReportUpdateAlarm.alarms.push(action.alarmObject);
        return {...state,reportDetails:newReportDetails,reportUpdateAlarms:newReportUpdateAlarm,change:!state.change}
    },
    [UPDATE_ALARM_IN_REPORT](state,action){
        let newReportDetails = state.reportDetails;
        let newReportUpdateAlarm = state.reportUpdateAlarms;
        const index = getIndexOfObjectIfExists(newReportDetails.alarms,action.alarmObject['client_id']);
        if(index !== -1){
            newReportDetails.alarms[index] = action.alarmObject;
        }
        const uindex = getIndexOfObjectIfExists(newReportUpdateAlarm.alarms,action.alarmObject['client_id']);
        if(uindex !== -1){
            newReportUpdateAlarm.alarms[uindex] = action.alarmObject
        }
        else {
            newReportUpdateAlarm.alarms.push(action.alarmObject);
        }
        return {...state,reportDetails:newReportDetails,reportUpdateAlarms:newReportUpdateAlarm,change:!state.change}
    },
    [DELETE_ALARM_IN_REPORT](state,action){
        let newReportDetails = state.reportDetails;
        const index = getIndexOfObjectIfExists(newReportDetails.alarms,action.alarmObject['client_id']);
        if(index !== -1){
            newReportDetails.alarms.splice(index,1);
        }
        let newReportUpdateAlarm = state.reportUpdateAlarms;
        const uindex = getIndexOfObjectIfExists(newReportUpdateAlarm.alarms,action.alarmObject['client_id']);
        if(uindex !== -1){
            if(newReportUpdateAlarm.alarms[uindex]['action'] === 'create'){
                newReportUpdateAlarm.alarms.splice(uindex,1);
            }
            else {
                newReportUpdateAlarm.alarms[uindex] = {...action.alarmObject,action:'delete'};
            }
        }
        else {
            newReportUpdateAlarm.alarms.push({...action.alarmObject,action:'delete'});
        }
        return {...state,reportDetails:newReportDetails,reportUpdateAlarms:newReportUpdateAlarm,change:!state.change}
    },
    [ADD_NEW_RECEIPT_INTO_REPORT](state,action){
        let newReportDetails = state.reportDetails;
        newReportDetails.receipts.push(action.receiptObject);
        let newReportUpdateReceipt = state.reportUpdateReceipts;
        newReportUpdateReceipt.receipts.push(action.receiptObject);
        return {...state,reportDetails:newReportDetails,reportUpdateReceipts:newReportUpdateReceipt,change:!state.change}
    },
    [UPDATE_RECEIPT_IN_REPORT](state,action){
        let newReportDetails = state.reportDetails;
        let newReportUpdateReceipt = state.reportUpdateReceipts;
        const index = getIndexOfObjectIfExists(newReportDetails.receipts,action.receiptObject['client_id']);
        if(index !== -1){
            newReportDetails.receipts[index] = action.receiptObject;
        }
        const uindex = getIndexOfObjectIfExists(newReportUpdateReceipt.receipts,action.receiptObject['client_id']);
        if(uindex !== -1){
            newReportUpdateReceipt.receipts[uindex] = action.receiptObject
        }
        else {
            newReportUpdateReceipt.receipts.push(action.receiptObject);
        }
        return {...state,reportDetails:newReportDetails,reportUpdateReceipts:newReportUpdateReceipt,change:!state.change}
    },
    [DELETE_RECEIPT_IN_REPORT](state,action){
        let newReportDetails = state.reportDetails;
        const index = getIndexOfObjectIfExists(newReportDetails.receipts,action.receiptObject['client_id']);
        if(index !== -1){
            newReportDetails.receipts.splice(index,1);
        }
        let newReportUpdateReceipt = state.reportUpdateReceipts;
        const uindex = getIndexOfObjectIfExists(newReportUpdateReceipt.receipts,action.receiptObject['client_id']);
        if(uindex !== -1){
            if(newReportUpdateReceipt.receipts[uindex]['action'] === 'create'){
                newReportUpdateReceipt.receipts.splice(uindex,1);
            }
            else {
                newReportUpdateReceipt.receipts[uindex] = {...action.receiptObject,action:'delete'};
            }
        }
        else {
            newReportUpdateReceipt.receipts.push({...action.receiptObject,action:'delete'});
        }
        return {...state,reportDetails:newReportDetails,reportUpdateReceipts:newReportUpdateReceipt,change:!state.change}
    },
    [ADD_NEW_METER_INTO_REPORT](state,action){
        let newReportDetails = state.reportDetails;
        newReportDetails.meters.push(action.metersObject);
        let newReportUpdateMeters = state.reportUpdateMeters;
        newReportUpdateMeters.meters.push(action.metersObject);
        return {...state,reportDetails:newReportDetails,reportUpdateMeters:newReportUpdateMeters,change:!state.change}
    },
        [UPDATE_METER_ABSENCE_IN_REPORT](state,action){
        let newReportDetails = state.reportDetails;
        newReportDetails.meter_absence_info = action.absenceInfo  
        return {...state,reportDetails:newReportDetails,change:!state.change}
    },
    [UPDATE_METER_IN_REPORT](state,action){
        let newReportDetails = state.reportDetails;
        newReportDetails.meters[action.meterIndex] = action.metersObject;
        let newReportUpdateMeters = state.reportUpdateMeters;
        const uindex = getIndexOfObjectIfExists(newReportUpdateMeters.meters,action.metersObject['client_id']);
        if(uindex !== -1){
            newReportUpdateMeters.meters[uindex] = action.metersObject;
        }
        else {
            newReportUpdateMeters.meters.push(action.metersObject);
        }
        return {...state,reportDetails:newReportDetails,reportUpdateMeters:newReportUpdateMeters,change:!state.change}
    },
    [DELETE_METER_IN_REPORT](state,action){
        let newReportDetails = state.reportDetails;
        const index = getIndexOfObjectIfExists(newReportDetails.meters,action.metersObject['client_id']);
        if(index !== -1){
            newReportDetails.meters.splice(index,1);
        }
        let newReportUpdateMeters = state.reportUpdateMeters;
        const uindex = getIndexOfObjectIfExists(newReportUpdateMeters.meters,action.metersObject['client_id']);
        if(uindex !== -1){
            newReportUpdateMeters.meters.splice(uindex,1);
        }
        else {
            let metersObj = action.metersObject;
            metersObj['action'] = 'delete';
            newReportUpdateMeters.meters.push(action.metersObject);
        }
        let newReadings = [];
        let numReadings = newReportUpdateMeters.readings.length;
        for(let i=0;i<numReadings;i++){
           if(newReportUpdateMeters.readings[i]['meter_id'] !== action.metersObject['client_id']){
               newReadings.push(newReportUpdateMeters.readings[i]);
           }
        }
        newReportUpdateMeters.readings = newReadings;
        return {...state,reportDetails:newReportDetails,reportUpdateMeters:newReportUpdateMeters,change:!state.change}
    },
    [DELETE_READING_IN_METER](state,action){
        let newReportDetails = state.reportDetails;
        newReportDetails.meters[action.meterIndex].readings.splice(action.readingIndex,1);
        let newReportUpdateMeters = state.reportUpdateMeters;
        const rindex = getIndexOfObjectIfExists(newReportUpdateMeters.readings,action.readingObject['client_id']);
        if(rindex !== -1) {
            newReportUpdateMeters.readings.splice(rindex,1);
        }
        else {
            let deletedObj = action.readingObject;
            deletedObj['action'] = 'delete';
            newReportUpdateMeters.readings.push(deletedObj);
        }
        return {...state,reportDetails:newReportDetails,reportUpdateMeters:newReportUpdateMeters,change:!state.change}
    },
    [UPDATE_READING_IN_METER](state,action){
        let newReportDetails = state.reportDetails;
        newReportDetails.meters[action.meterIndex].readings[action.readingIndex] = action.readingObject;
        let newReportUpdateMeters = state.reportUpdateMeters;
        const rindex = getIndexOfObjectIfExists(newReportUpdateMeters.readings,action.readingObject['client_id']);
        if(rindex !== -1) {
            newReportUpdateMeters.readings[rindex] = action.readingObject;
        }
        else {
            newReportUpdateMeters.readings.push(action.readingObject);
        }
        return {...state,reportDetails:newReportDetails,reportUpdateMeters:newReportUpdateMeters,change:!state.change}
    },
    [ADD_NEW_READING_IN_METER](state,action){
        let newReportDetails = state.reportDetails;
        newReportDetails.meters[action.meterIndex].readings.push(action.readingObject);
        let newReportUpdateMeters = state.reportUpdateMeters;
        newReportUpdateMeters.readings.push(action.readingObject);
        return {...state,reportDetails:newReportDetails,reportUpdateMeters:newReportUpdateMeters,change:!state.change}
    },
   [LOAD_ROOM_TEMPLATE](state, action) {
    let room = action.templateObject;

    // Create new copies for the new room, groups, and items
    const newRoom = {
        client_id: uuidv1(),
        name: room['name'],
        images: [],
        groups: [], // This will be populated with newGroup instances
        additional_notes: "",
        action: 'create'
    };

    // Use Array.prototype.map to create new instances of groups and items
    // and ensure immutability at each level.
    const newGroups = room['groups'].map(groupTemplate => {
        const newGroup = {
            room_id: newRoom['client_id'], // Reference the new room's ID
            client_id: uuidv1(),
            name: groupTemplate['name'],
            images: [],
            items: [], // This will be populated with newItem instances
            action: 'create'
        };

        const newItems = groupTemplate['items'].map(itemTemplate => {
            const newItem = {
                group_id: newGroup['client_id'], // Reference the new group's ID
                client_id: uuidv1(),
                name: itemTemplate['name'],
                images: [],
                action: 'create',
                ci_notes: ""
            };
            return newItem; // Return the new item
        });

        newGroup.items = newItems; // Assign the new, immutable items array
        return newGroup; // Return the new group
    });

    // Assign the new, immutable groups array to the new room
    newRoom.groups = newGroups;

    // Now, create truly new state objects based on the previous state
    // and your newly constructed immutable data.

    // 1. Copy reportDetails and its rooms array
    const updatedReportDetails = {
        ...state.reportDetails,
        rooms: [...state.reportDetails.rooms, newRoom] // Add newRoom to a new array
    };

    // 2. Copy reportUpdates and its arrays
    const updatedReportUpdates = {
        ...state.reportUpdates,
        // Ensure you're adding the new, immutable items and groups to the reportUpdates as well
        items: [...state.reportUpdates.items, ...newGroups.flatMap(group => group.items)],
        groups: [...state.reportUpdates.groups, ...newGroups],
        rooms: [...state.reportUpdates.rooms, { new: true, ...newRoom }] // Add newRoom with new:true
    };

    // Return a completely new state object
    return {
        ...state,
        reportDetails: updatedReportDetails,
        reportUpdates: updatedReportUpdates,
        change: !state.change // Toggle change to trigger re-render if necessary
    };
},
    [ADD_NEW_DISCLAIMER_INTO_REPORT](state,action){
        let imagesJ = action.disclaimerObject.images;
        for (let i = 0; i< imagesJ.length; i ++){
            state.reportUpdateDisclaimer.images.push(imagesJ[i]);
        }

        let newReportDetails = state.reportDetails;
        newReportDetails.disclaimers.push(action.disclaimerObject);
        let newReportUpdateDisclaimer = state.reportUpdateDisclaimer;
        newReportUpdateDisclaimer.disclaimers.push(action.disclaimerObject);
        return {...state,reportDetails:newReportDetails,reportUpdateDisclaimer:newReportUpdateDisclaimer,change:!state.change}
    },
    [UPDATE_DISCLAIMER_IN_REPORT](state,action){
        let newReportDetails = state.reportDetails;
        let newReportUpdateDisclaimer = state.reportUpdateDisclaimer;
        const index = getIndexOfObjectIfExists(newReportDetails.disclaimers,action.disclaimerObject['client_id']);
        if(index !== -1){
            newReportDetails.disclaimers[index] = action.disclaimerObject;
        }
        const uindex = getIndexOfObjectIfExists(newReportUpdateDisclaimer.disclaimers,action.disclaimerObject['client_id']);
        if(uindex !== -1){
            newReportUpdateDisclaimer.disclaimers[uindex] = action.disclaimerObject
        }
        else {
            newReportUpdateDisclaimer.disclaimers.push(action.disclaimerObject);
        }
        return {...state,reportDetails:newReportDetails,reportUpdateDisclaimer:newReportUpdateDisclaimer,change:!state.change}
    },
    [DELETE_DISCLAIMER_IN_REPORT](state,action){
        let newReportDetails = state.reportDetails;
        const index = getIndexOfObjectIfExists(newReportDetails.disclaimers,action.disclaimerObject['client_id']);
        if(index !== -1){
            newReportDetails.disclaimers.splice(index,1);
        }
        let newReportUpdateDisclaimer = state.reportUpdateDisclaimer;
        const uindex = getIndexOfObjectIfExists(newReportUpdateDisclaimer.disclaimers,action.disclaimerObject['client_id']);
        if(uindex !== -1){
            if(newReportUpdateDisclaimer.disclaimers[uindex]['action'] === 'create'){
                newReportUpdateDisclaimer.disclaimers.splice(uindex,1);
            }
            else {
                newReportUpdateDisclaimer.disclaimers[uindex] = {...action.disclaimerObject,action:'delete'};
            }
        }
        else {
            newReportUpdateDisclaimer.disclaimers.push({...action.disclaimerObject,action:'delete'});
        }
        return {...state,reportDetails:newReportDetails,reportUpdateDisclaimer:newReportUpdateDisclaimer,change:!state.change}
    },
    [ADD_MEDIA_TO_DISCLAIMER_OFFLINE](state, action) {
        state.reportUpdateDisclaimer.images.push(action.media);
        let disclaimerOnChange = state.reportDetails.disclaimers[action.disclaimerIndex];
        if (disclaimerOnChange['action'] === undefined) {
            disclaimerOnChange['action'] = 'update';
            disclaimerOnChange.images.push({id: action.media.id,image:action.media});
            const index = getIndexOfObjectIfExists(state.reportUpdateDisclaimer.disclaimers, disclaimerOnChange['client_id']);
            const disclaimerObjUpdate = {
                title: disclaimerOnChange['title'],
                client_id: disclaimerOnChange['client_id'],
                description: disclaimerOnChange['description'],
                action: disclaimerOnChange['action'],
                images: disclaimerOnChange['images'],
                section_type:disclaimerOnChange['section_type']
            };
            if (index !== -1) {
                state.reportUpdateDisclaimer.disclaimers[index] = disclaimerObjUpdate;
            }
            else {
                state.reportUpdateDisclaimer.disclaimers.push(disclaimerObjUpdate);
            }
        }
        else {
            disclaimerOnChange.images.push({id: action.media.id,image:action.media});
        }
        state.reportUpdateDisclaimer.disclaimers[action.disclaimerIndex] = disclaimerOnChange;

        return {...state};
    },
    [REMOVE_MEDIA_FROM_DISCLAIMER_OFFLINE](state, action) {
        state.reportDetails.disclaimers[action.disclaimerIndex]['images'] = state.reportDetails.disclaimers[action.disclaimerIndex].images.filter((image) => {
            return image['id'] !== action.media.serverId
        });
        if(state.reportUpdateDisclaimer['images'].length > 0){
            state.reportUpdateDisclaimer['images'] = state.reportUpdateDisclaimer['images'].filter((image)=>{
                return image['id'] !== action.media.serverId;
            });
        }
        return {...state,change:!state.change}
    },
    [UPDATE_ADDITIONAL_SUMMARY_IN_REPORT](state,action){
        let reportDetails = {...state.reportDetails};
        reportDetails.additional_summary_detail = action.additionalSummaryNotesObject
        return {...state,reportDetails:reportDetails}
    },
    [LOAD_AI_DATA](state,action){
        // 1. Create shallow copies of the top-level state properties that will change.
    //    We don't need to copy `reportDetails` and `reportUpdates` here yet,
    //    as we'll be building new versions of them from the ground up or
    //    by deep copying their relevant parts.
    let newReportDetailsRooms = [...state.reportDetails.rooms];
    let newReportUpdates = {
        ...state.reportUpdates,
        rooms: [...state.reportUpdates.rooms],
        groups: [...state.reportUpdates.groups],
        items: [...state.reportUpdates.items]
    };

    const parsedRooms = action.parsedRooms.rooms;
    const other_template = action.other_template;

    parsedRooms.forEach(room => {
        const newRoom = {
            client_id: uuidv1(),
            name: room['room_name'],
            images: [],
            groups: [], // This will be populated with new group objects
            additional_notes: "",
            action: 'create'
        };

        let newGroupsForRoom = [];

        room['groups'].forEach(group => {
            const newGroup = {
                room_id: newRoom['client_id'],
                client_id: uuidv1(),
                name: group['group_name'],
                images: [],
                items: [], // This will be populated with new item objects
                action: 'create'
            };
            let newItemsForGroup = []; // Temporarily store items for the current group
            group['items'].map(item => {
                const newItem = {
                    group_id: newGroup['client_id'],
                    client_id: uuidv1(),
                    name: item['item_name'],
                    images: [],
                    action: 'create',
                };
                if (other_template) { newItem["co_notes"] = item['item_condition'];} 
                else { newItem["ci_notes"] = item['item_condition'];}
                newReportUpdates.items.push(newItem);
                newItemsForGroup.push(newItem);
            });
            newGroup.items = newItemsForGroup; // Assign new array of items
            newGroupsForRoom.push(newGroup);
            // Add to the new report updates groups array
            newReportUpdates.groups.push(newGroup);
        });
        newRoom.groups = newGroupsForRoom; // Assign new array of groups
        newReportDetailsRooms.push({ ...newRoom }); // Deep copy for newReportDetails
        newReportUpdates.rooms.push({ new: true, ...newRoom }); // Deep copy with 'new' property
    });

    // 2. Return a brand new state object with updated properties.
    return {
        ...state,
        reportDetails: { ...state.reportDetails,   rooms: newReportDetailsRooms, },
        reportUpdates: newReportUpdates,    change: !state.change,    };
    },
    [LOAD_SAVE_STATE](state,action){
        // 1. Create shallow copies of the top-level state properties that will change.
    //    We don't need to copy `reportDetails` and `reportUpdates` here yet,
    //    as we'll be building new versions of them from the ground up or
    //    by deep copying their relevant parts.
    let newReportDetailsRooms = [...state.reportDetails.rooms];
    let newReportUpdates = {
        ...state.reportUpdates,
        rooms: [...state.reportUpdates.rooms],
        groups: [...state.reportUpdates.groups],
        items: [...state.reportUpdates.items]
    };
    const parsedRooms = action.parsedRooms;

    parsedRooms.forEach(room => {
        const newRoom = {
            client_id: uuidv1(),
            name: room['name'],
            images: [],
            groups: [], // This will be populated with new group objects
            additional_notes: room["additional_notes"]|| "",
            action: 'create'
        };

        let newGroupsForRoom = [];

        room['groups'].forEach(group => {
            const newGroup = {
                room_id: newRoom['client_id'],
                client_id: uuidv1(),
                name: group['name'],
                images: [],
                items: [], // This will be populated with new item objects
                action: 'create'
            };
            let newItemsForGroup = []; // Temporarily store items for the current group
            group['items'].map(item => {
                const newItem = {
                    group_id: newGroup['client_id'],
                    client_id: uuidv1(),
                    name: item['name'],
                    images: [],
                    action: 'create',
                    ci_notes: item["ci_notes"] || "",
                    co_notes: item["co_notes"] || "",
                    flag: item["flag"],
                    tenant_cost_category: item["tenant_cost_category"]

                };
                newReportUpdates.items.push(newItem);
                newItemsForGroup.push(newItem);
            });
            newGroup.items = newItemsForGroup; // Assign new array of items
            newGroupsForRoom.push(newGroup);
            // Add to the new report updates groups array
            newReportUpdates.groups.push(newGroup);
        });
        newRoom.groups = newGroupsForRoom; // Assign new array of groups
        newReportDetailsRooms.push({ ...newRoom }); // Deep copy for newReportDetails
        newReportUpdates.rooms.push({ new: true, ...newRoom }); // Deep copy with 'new' property
    });

    // 2. Return a brand new state object with updated properties.
    return {
        ...state,
        reportDetails: { ...state.reportDetails,   rooms: newReportDetailsRooms, },
        reportUpdates: newReportUpdates,    change: !state.change,    };
    },
    [LOG_ERROR_RESPONSE](state,action){
        return {...state,errorResponse:action.errorResponse,roomErrorResponse:action.roomErrorResponse}
    },
    [SET_SELECTED_OVERLAY_IMAGE](state,action){
        return {...state,overlayImage:action.overlayImage}
    },
    [UPDATE_OVERLAY_IMAGE_LIST](state,action){
        return {...state,overlayImageList:action.overlayImageList}
    }
});

export default reportReducer;


// WEBPACK FOOTER //
// ./src/reducers/report_reducer.js